import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { configureScope, TraceClassDecorator } from '@sentry/angular';
import { LogoutModal } from 'src/app/models/Login';
import { AuthService } from 'src/app/services/auth.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { PromiseResult } from '../../../../models/PromiseResult';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css']
})
@TraceClassDecorator()
export class LogoutComponent implements OnInit {
    seconds = { leftTime: 5, format: 's' };
    slug: string = "";
    logo_url: string = "";
    constructor(
        private readonly router: Router,
        private readonly authservice: AuthService,
        private readonly utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }
    private response = new PromiseResult();
    logoutuser: LogoutModal;
    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
        const user_guid = sessionStorage.getItem('userid');
        const access_token = sessionStorage.getItem('authtoken');
        const refresh_token = sessionStorage.getItem('refresh_token');
        this.logoutuser = {
            access_token: access_token,
            refresh_token: refresh_token,
            user_guid: user_guid
        };
        await this.authservice
            .logoutUser(this.logoutuser)
            .toPromise()
            .then((result) => {
                this.response = result;
            })
            .catch((error: HttpErrorResponse) => {
                console.log(error);
                this.response.success = true;
            });
        configureScope((scope) => scope.setUser(null));
        if (this.response.success) {
            sessionStorage.clear();
            this.router.navigate(['/' + this.slug + '/']);
        }
    }

    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }
}
